/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import { Loader } from 'lucide-react';

interface IssueListHeaderProps {
  filteredCount: number;
  totalCount: number;
  isArchiving: boolean;
  isLoading: boolean;
  onArchiveCompleted: () => void;
  onRefresh: () => void;
}

export function IssueListHeader({
  filteredCount,
  totalCount,
  isArchiving,
  isLoading,
  onArchiveCompleted,
  onRefresh
}: IssueListHeaderProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
      <h3 style={{ margin: 0 }}>Issues ({filteredCount} of {totalCount})</h3>
      <div style={{ display: 'flex', gap: '12px' }}>
        <button
          onClick={onArchiveCompleted}
          disabled={isArchiving || isLoading}
          className="btn"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '14px',
            padding: '8px 16px',
            backgroundColor: '#28a745',
            borderColor: '#28a745'
          }}
          title="Archive all completed issues to remove them from the active list"
        >
          {isArchiving ? (
            <>
              <Loader size={14} style={{ animation: 'spin 1s linear infinite' }} />
              Archiving...
            </>
          ) : (
            'Archive Completed'
          )}
        </button>
        <button
          onClick={onRefresh}
          disabled={isLoading || isArchiving}
          className="btn btn-secondary"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '14px',
            padding: '8px 16px'
          }}
        >
          {isLoading ? (
            <>
              <Loader size={14} style={{ animation: 'spin 1s linear infinite' }} />
              Loading...
            </>
          ) : (
            'Refresh'
          )}
        </button>
      </div>
    </div>
  );
}

